// extracted by css-extract-rspack-plugin
export default {"resetSection":"forgot-container__resetSection___QVpHn"};